import React from 'react';
import Notice from 'components/common/Notice/Notice';

const TONES = {
  'error-alert': 'danger',
  'warning-alert': 'warning',
  'info-alert': 'info',
  'internal-alert': 'info',
  'external-alert': 'warning',
};

// The older alert API, drawn as the design system's Notice: info1 is the
// title, info2 the text and footer a closing line. alertIcon and the
// border and size props are no longer used; the tone picks the icon.
const TSInfoAlert = ({ info1 = '', info2, footer, alertType = '', icon }) => (
  <Notice tone={TONES[alertType] ?? 'info'} title={info1} icon={icon}>
    {(info2 || footer) && (
      <>
        {info2 && <p>{info2}</p>}
        {footer && <p className="italic text-right">{footer}</p>}
      </>
    )}
  </Notice>
);

export default TSInfoAlert;
